import { jsxs as z, jsx as h, Fragment as A } from "react/jsx-runtime";
import { useState as p, useRef as T, useEffect as U } from "react";
import { useTranslation as P, TextLink as x, TextLinkStyle as $, Theme as N, Drawer as S } from "@nextgen-web-framework/all";
import { request as n, DateOrTime as D, DateFormats as E, formatDateTime as H } from "@nextgen-web-framework/core";
import { p as G } from "./utils-34ec0606.mjs";
import { t as W } from "./Projection-c26049e7.mjs";
import { T as i } from "./PaymentMethodId-cbeb8fbc.mjs";
import { ViewDetail as J } from "./components/internal-option-history/components/quantity-container/components/message-with-drawer/components/view-detail/ViewDetail.js";
import './assets/MessageWithDrawer.css';const Y = "/compaymentas/v1", c = (a) => a + Y, w = {
  get basePath() {
    return `${ApiConfigService.getBaseUrl()}/compaymentas/v1`;
  },
  /**
   *
   * @description - API Call to fetch transactions list
   *
   * @param filterOption Options that will be used to differentiate `AmPoint`, `AmPurse`, `Credit Voucher`
   * And sections `All`, `Redeemed`, `Received` and other's
   *
   * @returns List of Transactions.
   */
  // REMOVE THIS ANY WITH VALIDATE TYPE
  async getTransactionHistory(a, e, t) {
    const o = G({
      ...e,
      accountBalanceType: a
    });
    return await n.get({
      url: `${t != null && t.baseURL ? c(t.baseURL) : this.basePath}/account-balance-entries${o}`,
      ...(t == null ? void 0 : t.headers) && { headers: t == null ? void 0 : t.headers }
    });
  },
  /**
   * @description - TO BE USED IN FUTURE API Call to fetch Active Credit Vouchers of a User
   *
   * @returns List of Active Credit Voucher's
   */
  async getActiveCreditVouchers(a, e) {
    return await n.get({
      url: `${e != null && e.baseURL ? c(e.baseURL) : this.basePath}/credit-voucher?pageNumber=${a}`,
      ...(e == null ? void 0 : e.headers) && { headers: e == null ? void 0 : e.headers }
    });
  },
  /**
   * @description - TO BE USED IN FUTURE API Call to fetch expiring AmPoints
   *
   * @returns List of expiring AmPoints
   */
  async getExpiringAmPoints(a) {
    const e = ApiConfigService.getBaseUrl();
    return await n.get({
      url: `${a != null && a.baseURL ? a.baseURL : e}/comloyaltypointsas/v1/expiring-loyalty-balance`,
      ...(a == null ? void 0 : a.headers) && { headers: a == null ? void 0 : a.headers }
    });
  },
  /**
   * @description -API Call to fetch  AmPoints Balance
   *
   * @returns AmPoints Details
   */
  async getLoyalityBalance(a) {
    const e = ApiConfigService.getBaseUrl();
    return await n.get({
      url: `${a != null && a.baseURL ? a.baseURL : e}/comloyaltypointsas/v1/loyalty-balances`,
      ...(a == null ? void 0 : a.headers) && { headers: a == null ? void 0 : a.headers }
    });
  },
  /**
   * @description -API Call to fetch  Ampurse Balance
   *
   * @returns Ampurse Details
   */
  async getAmpurseBalance(a) {
    return await n.get({
      url: `${a != null && a.baseURL ? c(a.baseURL) : this.basePath}/account-balances?accountType=${i.OnAccountBalance}`,
      ...(a == null ? void 0 : a.headers) && { headers: a == null ? void 0 : a.headers }
    });
  },
  /**
   * @description -API Call to fetch  Credit Vouchers Total
   *
   * @returns Credit Vouchers Total
   */
  async getCreditVouchersTotal(a) {
    return await n.get({
      url: `${a != null && a.baseURL ? c(a.baseURL) : this.basePath}/credit-voucher?projection=${W.Summary}`,
      ...(a == null ? void 0 : a.headers) && { headers: a == null ? void 0 : a.headers }
    });
  },
  /**
   * @description -API Call to fetch  Internal Pmp Balance
   */
  async getCvBalance(a) {
    return await n.get({
      url: `${a != null && a.baseURL ? c(a.baseURL) : this.basePath}/account-balances?accountType=${i.CreditVoucher}`,
      ...(a == null ? void 0 : a.headers) && { headers: a == null ? void 0 : a.headers }
    });
  }
}, j = "#ffffff", F = "#396e75", q = "#e5fdff", X = "#546223", Z = "#f0fae5", I = "#a65523", K = "#fff1e8", Q = "#7f3e3e", M = "#ffe2e2", aa = "#62625a", ea = "#f8f8e7", ta = "#38539a", oa = "#707070", ra = "#c8f8d1", na = "#87c9c8", ia = "#5291b1", sa = "rgba(82, 145, 177, 0.1019607843)", ca = "#445685", la = "#181d61", da = "rgba(24, 29, 97, 0.1019607843)", ua = "#5969d6", ga = "#ea999d", ya = "#b6577e", ma = "rgba(182, 87, 126, 0.1019607843)", ha = "#7e3e80", pa = "#1e247f", fa = "rgba(30, 36, 127, 0.1019607843)", Ca = "#da7600", Va = "#107f47", ba = "#d91734", va = "_html_yw5iy_46", C = {
  amwayWhite: j,
  darkBlue: F,
  lightBlue: q,
  darkGreen: X,
  lightGreen: Z,
  darkOrange: I,
  lightOrange: K,
  darkRed: Q,
  lightRed: M,
  darkYellow: aa,
  lightYellow: ea,
  darkPurple: ta,
  darkGrayOnWhite: oa,
  dataVizColor1: ra,
  dataVizColor2: na,
  dataVizColor3: ia,
  dataVizColor3Background: sa,
  dataVizColor4: ca,
  dataVizColor5: la,
  dataVizColor5Background: da,
  dataVizColor6: ua,
  dataVizColor7: ga,
  dataVizColor8: ya,
  dataVizColor8Background: ma,
  dataVizColor9: ha,
  dataVizColor10: pa,
  dataVizColor10Background: fa,
  dataVizAlertOrange: Ca,
  dataVizSuccessGreen: Va,
  dataVizWarningRed: ba,
  "no-visible": "_no-visible_yw5iy_42",
  html: va,
  "message-container": "_message-container_yw5iy_80",
  "drawer-body": "_drawer-body_yw5iy_95",
  "info-message": "_info-message_yw5iy_95",
  "transactions-container": "_transactions-container_yw5iy_114",
  "header-container": "_header-container_yw5iy_117",
  "skeleton-loading": "_skeleton-loading_yw5iy_1"
}, Aa = ({
  paymentMethodId: a,
  expiringDate: e,
  expiringPoints: t
}) => {
  const o = P(), [k, V] = p(!1), [s, b] = p([]), [_, R] = p(""), [f, B] = p([]), l = a === i.AmwayPoints, d = T(0), L = (r, u, g, y) => {
    const m = ConfigService.getConfigs();
    return r ? H(
      r,
      { date: u, time: g },
      !1,
      m.NEXT_PUBLIC_TIMEZONE,
      void 0,
      y
    ) : "";
  }, v = async () => {
    var u, g, y;
    if (!(f != null && f.length) && d.current != 0 && a === i.CreditVoucher)
      return;
    const r = l ? await w.getExpiringAmPoints() : await w.getActiveCreditVouchers(d.current);
    if (d.current = d.current + 1, l)
      b(((u = JSON.parse(JSON.stringify(r))) == null ? void 0 : u.expiringBalanceDetails) || []), R(((g = JSON.parse(JSON.stringify(r))) == null ? void 0 : g.expiringDays) || "");
    else if (a === i.CreditVoucher && r) {
      const m = (y = JSON.parse(JSON.stringify(r))) == null ? void 0 : y.activeVouchers;
      B(m), b([...s, ...m]);
    }
  };
  U(() => {
    v();
  }, []);
  const O = /* @__PURE__ */ z("div", { className: C["info-message"], "data-testid": "info-message", "data-pod-name": "payment", children: [
    t,
    " ",
    o("payment.accountHistory.AmpointExpiring"),
    " ",
    _,
    " ",
    o("payment.accountHistory.AmpointExpiringDays")
  ] });
  return /* @__PURE__ */ h(A, { children: (s == null ? void 0 : s.length) > 0 && /* @__PURE__ */ z("div", { className: C["message-container"], "data-testid": "message-container", "data-pod-name": "payment", children: [
    l ? `${t} ${o("payment.accountHistory.AmPoints")} ${o(
      "payment.accountHistory.AmPoints.expiringOn"
    )} ${e ? L(e, E.LONG_DATE, void 0, D.DATE_ONLY) : ""}` : o("payment.accountHistory.CreditVoucher.active"),
    /* @__PURE__ */ h(
      x,
      {
        text: o("payment.accountHistory.View"),
        textLinkStyle: $.UNDERLINE,
        theme: N.PURPLE,
        onClick: () => V(!0),
        "data-testid": "link",
        "data-pod-name": "payment"
      }
    ),
    k && /* @__PURE__ */ h(
      S,
      {
        header: o(l ? "payment.accountHistory.AmPoints.expiring" : "payment.accountHistory.CreditVoucher.active"),
        onClose: () => V(!1),
        closeOnBackdropClick: !0,
        className: C["drawer-body"],
        bottomGap: 0,
        subHeader: a !== i.CreditVoucher && O,
        closeIcon: !0,
        children: /* @__PURE__ */ h(
          J,
          {
            paymentMethodId: a,
            transactions: s,
            fetchTransactions: v
          }
        )
      }
    )
  ] }) });
};
export {
  Aa as M,
  w as R
};
//# sourceMappingURL=MessageWithDrawer-56ed2007.mjs.map
